import React from 'react';
import { colors } from '../../constants.js/colors';
import { Grid, Typography } from '@material-ui/core';

const AuthFooterSecondary = () => {
    return (
        <Grid container justify="center" xs={12} style={{ backgroundColor: colors.primary.main, padding: '12px', gap: '8px' }}>
            <Typography display="inline" variant="caption">
                ⓒ 2025 Cometric S.A.S.
            </Typography>
            <Typography display="inline" variant="caption">
                |
            </Typography>
            <Typography display="inline" variant="caption">
                Todos los derechos reservados.
            </Typography>
            <Typography display="inline" variant="caption">
                |
            </Typography>
            <Typography display="inline" variant="caption">
                Términos y Condiciones
            </Typography>
            <Typography display="inline" variant="caption">
                |
            </Typography>
            <Typography display="inline" variant="caption">
                Contáctanos
            </Typography>
            <Typography display="inline" variant="caption">
                |
            </Typography>
            <Typography display="inline" variant="caption">
                Políticas de Privacidad
            </Typography>
        </Grid>
    );
};

export default AuthFooterSecondary;
